import { inject, Injectable, signal, Signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService, Result } from '@softline/core';
import { Belegart } from '@softapps/wws/gesamtabfrage/api';
import { BelegartRepository } from '../repositories/belegart.repository';
import { SOFTLINE_CONFIG_GESAMTABFRAGE } from '../gesamtabfrage.shared';

@Injectable()
export class BelegartService extends ReadonlyRepositoryCollectionService<Belegart, Result<Belegart[]>, undefined> {
  private readonly config = inject(SOFTLINE_CONFIG_GESAMTABFRAGE, { optional: true });

  override params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(BelegartRepository));
  }

  protected override getAll(result: Result<Belegart[]> | null | undefined): Belegart[] {
    const titles = this.config?.belegartTitles;
    const belegarten = result?.result ?? [];
    if (!titles) return belegarten;
    return belegarten.map((belegart) =>
      titles[belegart.id] ? { ...belegart, kundenName: titles[belegart.id] } : belegart
    );
  }
}
